const STORAGE_KEY = 'booka_notification_attribution';
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

export interface NotificationAttribution {
  source: 'notification';
  campaign: string;
  targetRoute?: string;
  targetBookId?: number;
  savedAt: number;
}

export function setNotificationAttribution(input: {
  campaign?: unknown;
  targetRoute?: unknown;
  targetBookId?: unknown;
}): void {
  const campaign = typeof input.campaign === 'string' ? input.campaign.trim() : '';
  if (!campaign) return;

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      source: 'notification',
      campaign,
      targetRoute: typeof input.targetRoute === 'string' ? input.targetRoute : undefined,
      targetBookId: typeof input.targetBookId === 'number' ? input.targetBookId : undefined,
      savedAt: Date.now(),
    } satisfies NotificationAttribution));
  } catch {
    // Analytics attribution must never block navigation or user actions.
  }
}

export function getNotificationAttribution(): NotificationAttribution | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as Partial<NotificationAttribution>;
    if (
      parsed.source !== 'notification' ||
      typeof parsed.campaign !== 'string' ||
      !parsed.campaign ||
      typeof parsed.savedAt !== 'number'
    ) {
      return null;
    }

    if (Date.now() - parsed.savedAt > MAX_AGE_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }

    return parsed as NotificationAttribution;
  } catch {
    return null;
  }
}

export function clearNotificationAttribution(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Ignore storage failures.
  }
}
